import { Popover } from '@mui/material';
import { useState } from 'react';

import StarIcon from '../../../assets/svg/StarIcon';
import TranscriptIcon from '../../../assets/svg/TranscriptIcon';
import { CALL_OUTCOME_LABEL_MAP, DATE_TIME_FORMAT } from '../../../constants';
import { IconButton } from '../../Shared';

export const Item = ({
  item,
  setCurrentRec,
  openListenRecordingModal,
  getFormattedRecordDate,
  openReadCallNotesModal,
  openStoplightAnalysisModal,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpenPopover = e => {
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="grid grid-cols-[32px_1fr_120px_32px] items-center gap-4 rounded-[20px] bg-white/50 p-5 w-full">
      <IconButton
        buttonProps={{
          className: 'w-8 h-8',
          onClick: () => {
            openListenRecordingModal();
            setCurrentRec(item);
          },
        }}
        iconProps={{
          name: 'play',
          className: 'h-6',
        }}
      />
      <div className="flex flex-col gap-0.5 truncate">
        <span className="text-brand-900 font-semibold text-[18px]/[24px] text-nowrap truncate">
          {item.ContactName}
        </span>
        <span className="text-base-800 font-medium text-[16px]/[24px] text-nowrap truncate">
          {item.CallType ? CALL_OUTCOME_LABEL_MAP[item.CallType] : '-'}
        </span>
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-base-1000 font-medium text-[16px]/[24px]">
          {getFormattedRecordDate(
            item.Timestamp,
            DATE_TIME_FORMAT.YYYY_MM_DD_DASH,
          )}
        </span>
        <span className="text-base-1000 font-medium text-[16px]/[24px]">
          {getFormattedRecordDate(item.Timestamp, DATE_TIME_FORMAT.hh_mm_ss_A)}
        </span>
      </div>
      <IconButton
        buttonProps={{
          className: 'w-8 h-8',
          onClick: onOpenPopover,
        }}
        iconProps={{
          name: 'dots',
          className: 'h-6',
        }}
      />
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-1 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[200px]',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="p-0.5 flex flex-col gap-0.5">
          <div
            className="flex items-center gap-2 py-1.5 px-2 cursor-pointer"
            onClick={() => {
              setCurrentRec(item);
              openReadCallNotesModal();
              onClosePopover();
            }}
          >
            <TranscriptIcon className="w-4 h-4 text-brand-900" />
            <span className="font-medium text-[14px]/[20px] text-base-1000">
              Transcript
            </span>
          </div>
          <div
            className="flex items-center gap-2 py-1.5 px-2 cursor-pointer"
            onClick={() => {
              setCurrentRec(item);
              openStoplightAnalysisModal();
              onClosePopover();
            }}
          >
            <StarIcon className="w-4 h-4 text-brand-900" />
            <span className="font-medium text-[14px]/[20px] text-base-1000">
              Score
            </span>
          </div>
        </div>
      </Popover>
    </div>
  );
};
